export const colors = {
  primary: 'rgba(48, 48, 48, 1)',
  gray_background: '#F1F1F1',
  warning: 'rgba(248, 217, 144, 1)',
  critical: 'rgba(245, 107, 82, 1)',
  danger: 'rgba(197, 40, 12, 1)',
  bgHover: '#f1f1f180',
};
